










// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/piscine/edit/EditTarif.vue'
import { getDefaultAloPiscine, AloPiscine } from '@/models/alo/AloPiscine'

@Component({
  name: 'ReadTarif',    
   props: {
    piscine:{      
      default:getDefaultAloPiscine()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadTarif extends Vue {
  private piscine!:AloPiscine
  private loading!:boolean
  
  get configuration(){
    return this.$store.myGetters.configuration
  }


  get forfaitDic(){
    return this.$store.myGetters.forfaitDic
  }

  created(){
    this.$store.myActions.ADM_FORFAIT_ENSURE()
  }

  edit() { (this.$refs.edit as Edit).edit(this.piscine) }
}
